// FeaturedProjectCard.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface FeaturedProject {
  id: string;
  title: string;
  title_name: string;
  description: string;
  color: string;
  techStack: string;
  readMoreLink?: string;
}

interface FeaturedProjectCardProps {
  project: FeaturedProject;
}

const FeaturedProjectCard: React.FC<FeaturedProjectCardProps> = ({ project }) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.boxShadow = '4px 4px 0 0 #000000';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.boxShadow = '2px 2px 0 0 #000000';
  };

  return (
    <Link 
      to={project.readMoreLink || '#'} 
      className="block h-full"
    >
      <div 
        className="bg-white text-black p-6 rounded flex flex-col h-full"
        style={{ 
          boxShadow: '2px 2px 0 0 #000000',
          border: '1px solid #000000',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Header section */}
        <div className="mb-4">
          <span className="source-code-pro-light text-sm inline-block mb-1">{project.title_name}</span>
          <h4 className="text-2xl font-bold mb-8">{project.title}</h4>
          <p>{project.description}</p>
        </div>
        
        {/* Body section - takes up flexible space */}
        <div className="flex-grow mb-6">
          <p className="text-base"></p>
        </div>
        
        {/* Footer section - fixed at bottom */}
        <div className="mt-auto">
          {/* Tech stack pills */}
          <div className="flex flex-wrap gap-1 mb-4 ">
            {project.techStack.split(/\s*-\s*/).map((tag, index) => (
              <span 
                key={index} 
                style={{ border: '1px solid #cccccc', display: 'inline-block' }}
                className="text-xs px-2 py-1 rounded-full source-code-pro-light"
              >
                {tag.trim()}
              </span>
            ))}
          </div>
          
          {/* Read more link */}
          <p className="text-right text-black text-sm">
            <span className="inline-flex items-center">
              Read more
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth={1.5} 
                stroke="currentColor" 
                className="w-4 h-4 ml-1 inline-block"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
              </svg>
            </span>
          </p>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedProjectCard;